<!-- Start Testimonials Area -->
<section class="testimonials-are">
    <div class="container">
        <div class="section-title mb-0 mt-0">
           <h1>Loved by Our Customers</h1>
<p>
  Real feedback from real people — see why customers continue to choose and recommend us.
</p>
        </div>
        <div class="google-reviews-header-row">
            <div class="google-logo-rating">
                <img src="https://www.gstatic.com/images/branding/product/1x/googleg_32dp.png" alt="Google"
                    class="google-logo" />
                <span class="google-rating">4.6</span>
                <span class="google-stars">
                    <ng-container *ngFor="let star of [].constructor(5)">&#9733;</ng-container>
                </span>
                <span class="google-review-count">(39)</span>
            </div>
        </div>
        <div class="google-reviews-carousel" (mouseenter)="onCarouselMouseEnter()"
            (mouseleave)="onCarouselMouseLeave()">
            <button class="carousel-arrow left" (click)="googlePrevReview()" [disabled]="!canGoPrev">&#8592;</button>
            <div class="reviews-row">
                <div class="review-card" *ngFor="let review of googleVisibleReviews">
                    <div class="review-header">
                        <ng-container *ngIf="review.image; else noImage">
                            <img [src]="review.image" alt="Reviewer photo" class="review-avatar"
                                (error)="onImageError(review)" />
                        </ng-container>
                        <ng-template #noImage>
                            <div class="review-avatar-initial">{{ review.name.charAt(0) }}</div>
                        </ng-template>
                        <div class="reviewer-info">
                            <div class="reviewer-name">{{ review.name }} <span class="verified"><i
                                        class="fa fa-check-circle"></i></span></div>
                            <div class="reviewer-google"><img
                                    src="https://www.gstatic.com/images/branding/product/1x/googleg_32dp.png"
                                    alt="Google" class="google-mini-logo" /></div>
                            <div class="review-date">{{ review.dateAgo }}</div>
                        </div>
                    </div>
                    <div class="review-stars">
                        <ng-container *ngFor="let star of [].constructor(review.rating)">&#9733;</ng-container>
                    </div>
                    <div class="review-text">
                        <ng-container *ngIf="googleExpandedReview !== review">
                            {{ review.text | slice:0:90 }}<span *ngIf="review.text.length > 90">... <a href="#"
                                    (click)="$event.preventDefault(); googleExpandReview(review)">Read more</a></span>
                        </ng-container>
                        <ng-container *ngIf="googleExpandedReview === review">
                            <span (click)="googleOpenModal(review)"
                                style="cursor:pointer; color:#333; text-decoration:none;">{{ review.text }}</span>
                            <a href="#" (click)="$event.preventDefault(); googleCollapseReview()"
                                style="margin-left:8px; font-size:0.95em;">Show less</a>
                        </ng-container>
                    </div>
                    <div class="review-images" *ngIf="review.reviewImageUrls && review.reviewImageUrls.length">
                        <ng-container *ngFor="let img of review.reviewImageUrls.slice(0,4); let i = index">
                            <img *ngIf="!review.failedReviewImages || !review.failedReviewImages[i]" [src]="img"
                                class="review-img-thumb" (error)="onReviewImgError(review, i)" />
                        </ng-container>
                        <span *ngIf="review.reviewImageUrls.length > 4" class="more-images">+{{
                            review.reviewImageUrls.length - 4 }}</span>
                    </div>
                </div>
            </div>
            <button class="carousel-arrow right" (click)="googleNextReview()" [disabled]="!canGoNext">&#8594;</button>
        </div>
        <!-- Modal -->
        <div class="modal-backdrop" *ngIf="googleModalOpen" (click)="googleCloseModal()">
            <div class="modal-content" (click)="$event.stopPropagation()">
                <button class="close-btn" (click)="googleCloseModal()">&times;</button>
                <img [src]="googleSelectedReview?.image" alt="Reviewer photo" class="modal-img" />
                <div class="modal-name">{{ googleSelectedReview?.name }}</div>
                <div class="modal-rating">
                    <ng-container
                        *ngFor="let star of [].constructor(googleSelectedReview?.rating)">&#9733;</ng-container>
                    <ng-container
                        *ngFor="let star of [].constructor(5 - googleSelectedReview?.rating)">&#9734;</ng-container>
                </div>
                <div class="modal-text">"{{ googleSelectedReview?.text }}"</div>
                <div class="modal-date">{{ googleSelectedReview?.dateAgo }}</div>
                <div class="modal-images"
                    *ngIf="googleSelectedReview?.reviewImageUrls && googleSelectedReview?.reviewImageUrls.length">
                    <img *ngFor="let img of googleSelectedReview.reviewImageUrls" [src]="img"
                        class="review-img-thumb" />
                </div>
            </div>
        </div>
    </div>

    <!-- Website Testimonials -->
    <!-- <div class="website-testimonials" *ngIf="websiteTestimonials.length">
        <div class="section-title" style="margin-top:60px;">
            <h1>What Our Customers Say</h1>
            <p>Feedback shared directly on our website</p>
        </div>

        <div class="website-testimonial-grid">
            <div class="website-testimonial-card" *ngFor="let t of websiteTestimonials">
                <div class="wt-message">
                    "{{ t.message }}"
                </div>
                <div class="wt-user">
                    — {{ t.name }}
                </div>
            </div>
        </div>
    </div> -->

    <div class="website-testimonials" *ngIf="websiteTestimonials.length">
  <div class="section-title">
    <p>Testimonials shared directly by our customers</p>
  </div>

  <div class="website-testimonials-slider position-relative">
    <!-- Left Arrow Button -->
    <button class="carousel-arrow left" (click)="websiteCarousel?.prev()">
      <i class='bx bx-chevron-left'></i>
    </button>

    <!-- Right Arrow Button -->
    <button class="carousel-arrow right" (click)="websiteCarousel?.next()">
      <i class='bx bx-chevron-right'></i>
    </button>

    <owl-carousel-o #websiteCarousel [options]="websiteTestimonialsOptions">
      <ng-template carouselSlide *ngFor="let t of websiteTestimonials">
        <div class="website-testimonial-card">
          <div class="wt-quote-icon">
            <i class="bx bxs-quote-left"></i>
          </div>

          <!-- Rating -->
          <div class="wt-rating" *ngIf="t.rating">
            <i class="bx bxs-star" *ngFor="let star of [].constructor(t.rating)"></i>
            <i class="bx bx-star" *ngFor="let star of [].constructor(5 - t.rating)"></i>
          </div>
          <div class="wt-rating" *ngIf="!t.rating">
            <i class="bx bxs-star" *ngFor="let star of [].constructor(5)"></i>
          </div>

          <div class="wt-message">
            "{{ t.message }}"
          </div>

          <div class="wt-footer">
            <div class="wt-avatar">
              <span>{{ t.name ? t.name.charAt(0).toUpperCase() : 'U' }}</span>
            </div>
            <div class="wt-info">
              <span class="wt-user-name">{{ t.name }}</span>
              <span class="wt-verified-badge"><i class="fa fa-check-circle"></i> Verified Customer</span>
            </div>
          </div>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</div>
</section>
<!-- End Testimonials Area -->



<!-- Testimonial Popup -->
<div class="testimonial-popup" *ngIf="openTestimonialForm">
    <div class="testimonial-form-card">
        <h3>Share Your Experience</h3>

        <input [(ngModel)]="testimonialData.name" placeholder="Your Name">
        <textarea [(ngModel)]="testimonialData.message" placeholder="Your Feedback"></textarea>

        <div class="btn-row">
            <button class="cancel" (click)="openTestimonialForm = false">Cancel</button>
            <button class="submit" (click)="submitTestimonial()">Submit</button>
        </div>
    </div>
</div>